import './styles/main.css'
import './utils/Logger'
import './utils/Environment'

import('@/app.js')
